import * as React from 'react';
import * as styles from './MultiSelectDropDown.css';

export interface IMultiSelectDropDownProps {
  placeholder?: string;
  label?: string;
  options: IMultiSelectDropDownOption[];
  styles?: React.CSSProperties;
  themeColor?: string;
  onSelectOptions(option: any): void;
  singleOption?: boolean;
}

export interface IMultiSelectDropDownState {
  checked: IMultiSelectDropDownOption[];
  dropDownValue: IMultiSelectDropDownOption[];
}

export interface IMultiSelectDropDownOption {
  key: any;
  text: string;
  selected: boolean;
}

export class IAMultiSelectDropDown extends React.Component<IMultiSelectDropDownProps, IMultiSelectDropDownState> {
  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.options?.filter((x) => x.selected),
      dropDownValue: [],
    };
  }

  componentDidMount = () => {
    this.setState({
      dropDownValue: this.props.options,
    });
  };

  componentDidUpdate = (props) => {
    if (props.options !== this.props.options) {
      this.setState({ dropDownValue: this.props.options, checked: this.props.options?.filter((x) => x.selected)});
    }
  };

  removeSelectedItem = (value) => {
    this.checkBox(value, false);
  };

  checkBox = (value, condition) => {
    let checkedValue = this.state.checked;
    let options = this.props.options;
    let selected = options.filter((x) => x.key === value)[0];

    if (!this.props.singleOption) {
      if (condition) {
        selected.selected = true;
        checkedValue.push(selected);
      } else {
        let index = checkedValue.indexOf(value);
        checkedValue.splice(index, 1);
        selected.selected = false;
      }
    } else {
      checkedValue = [];
      options.forEach((item) => {
        item.selected = false;
      });
      if (condition) {
        selected.selected = true;
        checkedValue.push(selected);
      } else {
        // let index = checkedValue.indexOf(value);
        // checkedValue.splice(index, 1);
        selected.selected = false;
      }
    }
    this.setState(
      {
        checked: checkedValue,
      },
      () => {
        this.props.onSelectOptions(options);
      }
    );
  };

  search = (e) => {
    if (e.target.value.length !== 0) {
      let enteredValue = e.target.value.toLowerCase();
      let presentValue = this.props.options.filter(function (data) {
        return data.text.toLocaleLowerCase().indexOf(enteredValue) > -1;
      });
      this.setState({ dropDownValue: presentValue });
    } else {
      this.setState({ dropDownValue: this.props.options });
    }
  };

  returnSelectedItems() {
    const selectedItem = this.state.checked
      ? this.state.checked.map((data, index) => (
          <div className={styles['selectedItem-body']} style={{ backgroundColor: !!this.props.themeColor ? this.props.themeColor : 'rgb(35, 135, 155);' }} key={index}>
            <p className={styles['selectedItem-text']}>{data.text}</p>
            <button className={styles['selectedItem-close']} onClick={() => this.removeSelectedItem(data.key)}>
              &times;
            </button>
          </div>
        ))
      : [];
    return selectedItem;
  }

  returnList() {
    const list = this.state.dropDownValue
      ? this.state.dropDownValue.map((data, index) => (
          <label className={styles.container} key={index}>
            {data.text}
            <input
              type="checkbox"
              value={data.key}
              onChange={(e) => this.checkBox(e.target.value, e.target.checked)}
              checked={this.state.checked.filter((x) => x.key === data.key)[0] ? true : false}
            />
            <span
              className={styles.checkmark}
              style={this.state.checked.filter((x) => x.key === data.key)[0] ? { backgroundColor: this.props.themeColor, borderColor: this.props.themeColor } : { borderColor: this.props.themeColor }}
            ></span>
          </label>
        ))
      : null;
    return list;
  }

  render() {
    return (
      <div className={styles.multiSelect} style={this.props.styles}>
        {!!this.props.label && <label className={styles['label-text']}>{this.props.label}</label>}
        <input type="text" name="Search" placeholder={this.props.placeholder} className={styles['input-box']} onChange={(e) => this.search(e)} />
        <div className={styles['search-result']}>
          <div className={styles['list-result']}>{this.returnList()}</div>
        </div>
        <div className={styles.selectedItem}>{this.returnSelectedItems()}</div>
      </div>
    );
  }
}
